/* eslint-disable react/display-name */
import React, { lazy, memo } from "react";
import SmartScaleBBSManagePage from "./pages/bbs-manage";
import { Navigate } from "react-router-dom";

const SmartScaleManagePage = lazy(() => import("./pages/manage"));
const SmartScaleV2ManagePage = lazy(() => import("./pages/manage-v2"));
const SmartScaleCameraPage = lazy(() => import("./pages/camera"));
const SmartScaleOrderPage = lazy(() => import("./pages/order"));
const SmartScaleStationPage = lazy(() => import("./pages/station"));
const SmartScaleDashboardPage = lazy(() => import("./pages/dashboard"));
const SmartScaleLogPage = lazy(() => import("./pages/logs"));
const SmartScaleBarCodeLogPage = lazy(() => import("./pages/barcode-logs"));
const SmartScaleBarCodeLogV2Page = lazy(
  () => import("./pages/barcode-logs/BarcodeV2")
);
const SmartScaleOrderUnusualPage = lazy(() => import("./pages/order-unusual"));
const SmartScaleFirmwarePage = lazy(() => import("./pages/firmware"));
const SmartScaleCameraFirmware = lazy(() => import("./pages/camera-firmware"));
const SmartScaleControllerPage = lazy(() => import("./pages/controller"));
const SmartScaleAbnormalHeightPage = lazy(
  () => import("./pages/order-abnormal-height")
);
const SmartScaleManageDevicePage = lazy(
  () => import("./pages/manage/index-device")
);
const SmartScaleV2ManageDevicePage = lazy(
  () => import("./pages/manage-v2/index-device")
);
const BarcodeLogV2Page = lazy(() => import("./pages/logs-v2"));

const SmartScaleRoutes = [
  { path: "manage", element: <SmartScaleManagePage /> },
  { path: "scale-camera", element: <SmartScaleCameraPage /> },
  { path: "scale-order", element: <SmartScaleOrderPage /> },
  { path: "scale-unusual", element: <SmartScaleOrderUnusualPage /> },
  { path: "scale-station", element: <SmartScaleStationPage /> },
  { path: "dashboard", element: <SmartScaleDashboardPage /> },
  { path: "scale-log", element: <SmartScaleLogPage /> },
  { path: "abnormal-height", element: <SmartScaleAbnormalHeightPage /> },
  { path: "manage-device", element: <SmartScaleManageDevicePage /> },
  { path: "*", element: <Navigate to="/smartScale/manage" /> }
];

export const SmartScaleV2Routes = [
  { path: "barcode-log", element: <SmartScaleBarCodeLogPage /> },
  { path: "manage", element: <SmartScaleV2ManagePage /> },
  { path: "firmware", element: <SmartScaleFirmwarePage /> },
  { path: "camera-firmware", element: <SmartScaleCameraFirmware /> },
  { path: "controller", element: <SmartScaleControllerPage /> },
  { path: "barcode-v2", element: <SmartScaleBarCodeLogV2Page /> },
  { path: "manage-device", element: <SmartScaleV2ManageDevicePage /> },
  { path: "bbs-manage", element: <SmartScaleBBSManagePage /> },
  { path: "logs", element: <BarcodeLogV2Page /> }
];
export default SmartScaleRoutes;
